import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import styles from './ToggleSwitch.css';
import classNames from 'classnames';
import { commonMessages } from '../messages/Common';

class ToggleSwitch extends PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    descriptionLeft: PropTypes.object,
    descriptionRight: PropTypes.object,
    className: PropTypes.string,
    lightsAlwaysOn: PropTypes.bool,
    intl: intlShape.isRequired,
  };

  render() {
    const {
      disabled,
      checked,
      id,
      onChange,
      name,
      descriptionLeft,
      descriptionRight,
      className,
      lightsAlwaysOn,
      intl,
    } = this.props;

    return (
      <div className={classNames(styles.toggleSwitch, className)}>
        <label htmlFor={id} className={styles.descriptionLeft}>
          {descriptionLeft}
        </label>
        <label
          className={styles.component}
          data-test="toggle-switch.btn"
          data-test-active={checked}
          aria-label={
            checked
              ? intl.formatMessage(commonMessages.deselect, { title: '' })
              : intl.formatMessage(commonMessages.select, { title: '' })
          }
        >
          <input
            className={styles.input}
            disabled={disabled}
            type="checkbox"
            checked={checked}
            id={id}
            onChange={onChange}
            name={name}
          />
          <span
            className={classNames(styles.slider, {
              [styles.sliderLightOn]: lightsAlwaysOn,
            })}
          />
        </label>
        <label htmlFor={id} className={styles.descriptionRight}>
          {descriptionRight}
        </label>
      </div>
    );
  }
}

export default injectIntl(ToggleSwitch);
